import { CheckboxField } from '@shared/ui/Inputs';
import { Controller, useFormContext } from 'react-hook-form';
import { useTexts } from '@/feature/lang';
import type { CheckboxProps } from './types';
import { useValidation } from './useValidation';

const FormCheckbox = ({
  label,
  registerControl,
  validation: validationBase,
  ...rest
}: CheckboxProps) => {
  const texts = useTexts();
  const validation = useValidation(validationBase, { label });

  const props = {
    label,
    requiredLabel: texts.component.form.label.required,
    showRequiredLabel: Boolean(validation?.required),
    ...rest,
  };

  return registerControl ? (
    <RegisteredControl {...props} validation={validation} />
  ) : (
    <BasicCheckbox {...props} />
  );
};

const BasicCheckbox = ({ label, ControlProps, ...props }: any) => {
  return (
    <CheckboxField
      {...props}
      label={label}
      controlProps={ControlProps}
      disableRipple
    />
  );
};

const RegisteredControl = ({
  validation,
  name,
  label,
  ControlProps,
  ...props
}: any) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const error = name && errors[name];
  const helperText = error && (error.message || 'validation error');

  return (
    <Controller
      name={name}
      control={control}
      rules={validation}
      defaultValue={false}
      render={({ field: { value, onChange } }) => (
        <CheckboxField
          {...props}
          checked={!!value}
          onChange={(e) => onChange(e.target.checked)}
          label={label}
          helperText={helperText}
          error={Boolean(error)}
          controlProps={ControlProps}
          disableRipple
        />
      )}
    />
  );
};

export default FormCheckbox;
